import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "icon"]

  connect() {
    this.updateUI()
  }

  toggle() {
    const html = document.documentElement
    const isDark = html.getAttribute("data-theme") === "dark"
    const newTheme = isDark ? "light" : "dark"
    
    // Toggle DaisyUI theme
    html.setAttribute("data-theme", newTheme)
    
    // Toggle dark mode class
    html.classList.toggle("dark")
    
    // Save to localStorage
    localStorage.setItem("theme", newTheme)
    
    // Update theme-color meta tag for mobile
    const themeColorMeta = document.getElementById('theme-color-meta')
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', newTheme === 'dark' ? '#141414' : '#F2F2F2')
    }
    
    this.updateUI()
  }

  updateUI() {
    const isDark = document.documentElement.getAttribute("data-theme") === "dark"
    const translations = document.querySelector('meta[name="translations"]')
    
    // Get translations from meta tag
    const lightText = translations.getAttribute('data-ambassador_portal.common.theme_light')
    const darkText = translations.getAttribute('data-ambassador_portal.common.theme_dark')
    
    // Show the current theme
    this.labelTarget.textContent = isDark ? darkText : lightText
    
    this.iconTarget.setAttribute("icon", isDark ? "ph:moon" : "ph:sun")
  }
} 